import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";
import { NgSelectModule } from "@ng-select/ng-select";
import { ComponentsModule } from "../components/components.module";

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule,
    ComponentsModule,
  ],
  exports: [ComponentsModule, FormsModule, ReactiveFormsModule, NgSelectModule],
})
export class PagesModule {}
